<template>
  <div>
    <div class="name_group">
      <el-select disabled style="width: 200px" v-model="projectName" size="small" clearable placeholder="版本号">
        <el-option label="版本1" :value="1"></el-option>
      </el-select>
      <el-select style="width: 150px" v-model="agentId" size="small" clearable placeholder="代理商">
        <el-option v-for="item in agentList" :label="item.name" :value="item.id" :key="item.id"></el-option>
      </el-select>
      <el-select style="width: 150px" v-model="settleType" size="small" clearable placeholder="结算类型">
        <el-option label="整单结算" :value="0"></el-option>
        <el-option label="月度暂结" :value="1"></el-option>
        <el-option label="整单暂结" :value="2"></el-option>
      </el-select>
      <el-select style="width: 150px"  v-model="dataType" size="small" clearable placeholder="请选择结算数据源">
        <el-option label="秒针IES" :value="1"></el-option>
        <el-option label="乐播云" :value="2"></el-option>
        <el-option label="客户数据-实结" :value="3"></el-option>
        <el-option label="客户数据-全结" :value="4"></el-option>
        <el-option label="历史结算导入" :value="5"></el-option>
      </el-select>
      <el-input style="width: 200px"  size="small" v-model="search" clearable placeholder="项目/编号"></el-input>
      <el-button @click="searchData" size="small" type="success">查询</el-button>
      <el-button @click="editDataType" icon="el-icon-edit" size="small" type="warning">修改</el-button>
      <el-button @click="updateDataDialogShow = true" icon="el-icon-upload" size="small" type="primary">上传数据</el-button>
      <el-button @click="originalOrderDialogShow = true" size="small" type="primary">原始订单</el-button>
      <el-button @click="getDataUpdateStatus" icon="el-icon-refresh" size="small" type="success">刷新</el-button>
      <span class="refresh-warp">
        <template v-if="updateStatus === 1">
          乐播云及IES数据 数据更新中，请稍侯......
        </template>
        <template v-else>
          乐播云及IES数据更新时间：{{ updateTime || '无' }} <el-button @click="updateProjectData" type="text">更新数据</el-button>
        </template>
      </span>
    </div>
    <el-table :max-height="tableHeight"
      v-loading="listLoading" element-loading-text="加载中" border
      @selection-change="handleSelectionChange"
      :data="tableData">
      <el-table-column align="center" type="selection" width="50"></el-table-column>
      <el-table-column align="center" fixed prop="agentName" label="代理商" width="200"></el-table-column>
      <el-table-column align="center" fixed prop="orderNo" label="项目编号" width="200"></el-table-column>
      <el-table-column align="left" label="项目名称" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.parentId > 0 ? '【子项目】': ''}}{{scope.row.orderName}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="结算类型" width="120">
        <template slot-scope="scope">
          <span :class="
                        scope.row.settleType == 2
                          ? 'red'
                          : scope.row.settleType == 0
                          ? 'green'
                          : scope.row.settleType == 1
                          ? 'blue'
                          : ''
                        ">{{ scope.row.settleType | adSettleStatus }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="结算数据源" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.dataType | adSettleSource }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" prop="customerCurrCpm" label="上传数据(整单)" width="120">
        <template slot-scope="scope">
          <template v-if="scope.row.dataType === 1 || scope.row.dataType === 2">
            <span></span>
          </template>
          <template v-else>
            {{ scope.row.customerCurrCpm > 0 ? scope.row.customerCurrCpm : '待上传' }}
          </template>
          <span></span>
        </template>
      </el-table-column>
      <el-table-column align="right" prop="totalCpm" label="IES数据">
        <template slot-scope="scope">
          <span>{{ scope.row.iesCurrCpm > -1 ? scope.row.iesCurrCpm : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" prop="lbTotalCpm" label="乐播云" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.lbCurrCpm > -1 ? scope.row.lbCurrCpm : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" fixed="right" width="100" label="原始订单">
        <template slot-scope="scope">
          <span v-if="scope.row.sfileName==''" >待上传</span>
          <el-button @click="downloadOrgin(scope.row)" v-else size="mini" type="text">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table_pagination">
      <el-pagination class="app-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNo" :page-sizes="pageSizeArr" :page-size="pageSize" :layout="paginationLayout" :total="totalEl">
      </el-pagination>
    </div>
    <editProjectDialog :projectDialogFlag.sync="projectDialogShow" :projectInfo="projectInfo" :changeProject="selectProject"></editProjectDialog>
    <updateDataDailog :updateDataDialogFlag.sync="updateDataDialogShow" :projectInfo="projectInfo"></updateDataDailog>
    <originalOrderDialog :orginalOrderDialogFlag.sync="originalOrderDialogShow" :projectInfo="projectInfo"></originalOrderDialog>
  </div>
</template>
<script>
import { settleDetailOrders, updateIesLbData, getDataUpdateStatus, getAgentList } from '@/api/projectSettlement/procedure'
import { exportOrderList } from '@/services'
import pagination from '@/util/mixins/pagination'
import editProjectDialog from '../dialogs/editProjectDialog.vue'
import updateDataDailog from '../dialogs/updateDataDailog'
import originalOrderDialog from '../dialogs/originalOrderDialog'
export default {
  mixins: [pagination],
  props: {
    projectInfo: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    projectName () {
      return `${this.projectInfo.month}.V${this.projectInfo.version}.${this.projectInfo.name}(起草中)`
    }
  },
  data() {
    return {
      refreshing: false,
      updateTime: '', // 更新时间
      updateStatus: 0, // 审核的状态
      showDetails: false, // 详情弹窗,
      // 修改项目弹窗
      projectDialogShow: false,
      // 上传数据弹窗
      updateDataDialogShow: false,
      // 原始数据弹窗
      originalOrderDialogShow: false,
      // 选择的项目
      selectProject: [],
      // 代理商
      agentId: '',
      // 结算类型
      dataType: '',
      // 结算数据源
      settleType: '',
      // 项目'编号
      search: '',
      // 代理商列表
      agentList: []
    }
  },
  mounted () {
    console.log('2.导入数据-------------')
    this.getDataUpdateStatus()
    this.getAgentList()
  },
  components: {
    editProjectDialog,
    updateDataDailog,
    originalOrderDialog
  },
  methods: {
    // 获取列表
    getList () {
      this.listLoading = true
      let postData = {
        settleId: this.projectInfo.id,
        agentId: this.agentId,
        dataType: this.dataType,
        settleType: this.settleType,
        search: this.search,
        current: this.pageNo,
        size: this.pageSize
      }
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.data
          this.totalEl = res.data.data.totalCount
        } else {
          this.$message.error(res.data.msg)
        }
      }
      settleDetailOrders(postData).then(onSuccess).catch(() => { this.listLoading = false })
    },
    getAgentList() {
      getAgentList({
        settleId: this.projectInfo.id
      }).then( res => {
        if(res.data.code === 200) {
          this.agentList = res.data.data
          console.log(this.agentList)
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch( err => {
        this.$message.error(err)
      })
    },
    // 更新数据
    updateProjectData() {
      this.$confirm("如果之前导入过IES及乐播云数据，执行后之前数据会被清除掉，请确认是否执行", "请确认是否更新数据？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 更新数据
          updateIesLbData({settleId: this.projectInfo.id}).then( res => {
            console.log(res.data)
            if (res.data.code === 200) {
              // this.refreshing = true
              this.updateStatus = 1
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch( err => {
            this.$message.error(err)
          })
        }).catch(() => {
          console.log('取消更新数据')
        })
    },
    searchData() {
      this.pageNo = 1
      this.getList()
    },
    // 刷新更新数据的状态
    getDataUpdateStatus() {
      // 1. 更新表格
      this.getList()
      // 2. 更新数据的更新时间
      getDataUpdateStatus({settleId: this.projectInfo.id}).then( res => {
        if(res.data.code === 200 ) {
          this.updateStatus = res.data.data.status
          if(res.data.data.status === 3) this.updateTime = res.data.data.freshEndDateTime
        }else {
          this.$message.error(res.data.msg)
        }
      }).catch( err => {
        this.$message.error(err)
      })
    },
    downloadOrgin(row) {
      window.open(row.sfileUrl)
    },
    // 选择项目
    handleSelectionChange(val) {
      this.selectProject = val
    },
    editDataType() {
      if(this.selectProject.length > 0) {
        this.projectDialogShow = true
      } else {
        this.$message.warning('请先选择项目')
      }
    },
    // 导出
    exportList () {
      let postData = {
        reviewCode: 11,
        refundOrderNo: this.refundNo,
        orderId: this.orderNo,
        mobile: this.userAccount,
        reviewTime: this.searchTime,
        refundReviewStatus: this.searchStatus
      }
      exportOrderList(postData)
    }
  },
  watch: {
    projectDialogShow (val) {
      if(!val) {
        this.getList()
      }
    },
    projectInfo() {
      this.getDataUpdateStatus()
    }
  }
}
</script>
<style lang="scss" scoped>
.refresh-warp {
  float: right;
  font-size: 14px;
  padding-left: 15px;
  line-height: 32px;
}
.red {
  color: red;
}
.blue {
  color: blue;
}
.green {
  color: green;
}
.el-select, .el-input {
  margin-right: 5px;
}
</style>